import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { PageHyundaiPromise } from '../../api/api-types';
import type { Loadable, Loaded } from '../../guards/ngrx-loader.guard';
import { actions } from './hyundai-promise.actions';

interface Content {
    content: Loadable<PageHyundaiPromise>;
    error: string | null;
}

const initialState: Content = {
    content: null,
    error: null,
};

export const state = createFeature({
    name: 'promise',
    reducer: createReducer(
        initialState,

        on(
            actions.loadHyundaiPromise,
            (state): Content => ({
                ...state,
                content: null,
                error: null,
            }),
        ),
        on(
            actions.loadHyundaiPromiseSuccess,
            (state, { content }): Content => ({
                ...state,
                content: content,
            }),
        ),
        on(
            actions.loadHyundaiPromiseFailure,
            (state, { error }): Content => ({
                ...state,
                error: error,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingPromise = createSelector(
            baseSelectors.selectContent,
            baseSelectors.selectError,
            (promiseContent, error) => promiseContent === null && error === null,
        );
        const selectLoadedContent = createSelector(
            baseSelectors.selectContent,
            (content) => content as Loaded<PageHyundaiPromise>,
        );
        return {
            selectIsLoadingPromise,
            selectLoadedContent,
        };
    },
});
